// Mutation hook - otworz ponownie zamknieta transakcje
// POST /api/ui/sales-crm/deals/{id}/reopen

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

interface IPostDealReopenResponse {
  data?: { id?: number; stage?: string };
  message?: string;
  status?: string;
}

const postDealReopen = (id: number): Promise<IPostDealReopenResponse> =>
  axios.post(`/sales-crm/deals/${id}/reopen`);

export const usePostDealReopen = (
  options?: UseMutationOptions<IPostDealReopenResponse, IError, number>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IPostDealReopenResponse, IError, number>(postDealReopen, {
    ...options,
    onSuccess: async (data, id, context) => {
      await queryClient.invalidateQueries(['sales-crm-deals-kanban']);
      await queryClient.invalidateQueries(['sales-crm-deals']);
      await queryClient.invalidateQueries(['sales-crm-deal', id]);
      await queryClient.refetchQueries(['sales-crm-deal', id]);
      options?.onSuccess?.(data, id, context);
    },
  });
};
